export default __webpack_public_path__ + "static/media/database-icon.a0b7d6b1.svg";